import { css } from 'emotion';
import { getInterUIDynamicMetricCssObject } from 'fonts/Inter-UI/metrics';
import { animationTransition } from '@joykit/variables';

export namespace styles {
  export const container = css({
    marginTop: 16,
    overflowY: 'scroll'
  });

  export const listContainer = css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column'
  });

  export const listItem = css({
    display: 'inline-block',
    marginBottom: 16
  });

  export const navLink = css({
    color: '#333',
    cursor: 'pointer',
    padding: 10,
    ...getInterUIDynamicMetricCssObject(15),
    transition: animationTransition('color'),
    '&.active': {
      cursor: 'default'
    },
    ':hover': {
      color: '#e8b0b3'
    }
  });

  export const svg = css({
    marginRight: 8,
    ' svg': {
      height: 14
    }
  });

  export const navButton = css({
    padding: '8px 8px',
    textDecoration: 'none',
    color: '#333',
    border: '1px solid #ebebeb',
    borderRadius: '5px',
    transition: animationTransition('border-color', 'background-color'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  });

  export const mobileHeader = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '1rem',
    paddingTop: '2rem'
  });

  export const popupPosition = css({
    zIndex: 10
  });

  export const flexLogo = css({
    display: 'flex',
    justifyContent: 'center',
    marginLeft: 16
  });

  export const getStartedWrapper = css({
    display: 'flex',
    justifyContent: 'flex-start',
    marginRight: 16
  });

  export const menuWrapper = css({
    display: 'flex',
    justifyContent: 'flex-end'
  });

  export const buttonWrapper = css({
    display: 'flex'
  });

  export const featuresContainer = (featuresIsOpen: boolean) =>
    css(
      {
        marginLeft: '1rem',
        display: 'flex',
        overflowY: 'hidden',
        transitionProperty: 'all',
        transitionDuration: '.5s',
        transitionTimingFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
        flexDirection: 'column',
        ' > *:not(:last-child)': {
          marginBottom: 16
        }
      },
      featuresIsOpen
        ? {
            maxHeight: 500
          }
        : {
            maxHeight: 0
          }
    );
}
